// src/routeMVP1010/RequireAuth.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/", { replace: true, state: { from: location } });
      setReady(true);
      return;
    }
    setReady(true);
  }, [navigate, location]);

  if (!ready) return <div style={{ padding: 12, textAlign: "center", color: "#6b7280" }}>Loading…</div>;
  return children;
}
